import React from "react";
import Modal from 'react-bootstrap/Modal';
import {
  ModalDowloadContent,
} from './styles';
import Loading from '~/components/layout/Loading';

export default function ModalDownload({
  modalDowload,
  setmodalDowload,
  dowloadItems,
  vouchers,
  loadingDownload,
}) {
  return(
    <Modal
      show={modalDowload}
      onHide={() => {
        setmodalDowload(false);
      }}
      className="modal-vale-gas"
      centered={window.screen.width >= 768}
    >
      <Modal.Body>
        <ModalDowloadContent>
          {
            loadingDownload ? (
              <Loading />
            ) : (
              <>
                <h3>Download da lista</h3>
                <p>
                  Você tem certeza que deseja fazer o download de
                  <strong> {vouchers.length} registros</strong> da sua lista?
                </p>
                <div>
                  <button
                    className="cancel"
                    onClick={() => setmodalDowload(false)}
                  >
                    Cancelar
                  </button>
                  <button className="dowload" onClick={() => dowloadItems()}>
                    Sim
                  </button>
                </div>
              </>
            )
          }
        </ModalDowloadContent>
      </Modal.Body>
    </Modal>
  );
}